import { ParsedUrlQuery } from 'querystring'
import {
  INVENTORY_ARCADE_SORT_OPTIONS,
  INVENTORY_SORT_OPTIONS,
  LISTING_SORT_OPTIONS,
  SortOption
} from '@/constants'

export const getInventorySortOptions = (
  query: ParsedUrlQuery,
  options: SortOption[],
  defaultOption: SortOption
): { options: SortOption[]; defaultOption: SortOption } => {
  if (options && defaultOption) {
    return {
      options,
      defaultOption
    }
  }

  const result = {
    options: undefined,
    defaultOption: undefined
  }

  if (query.exclude_non_arcade) {
    result.options = INVENTORY_ARCADE_SORT_OPTIONS
    result.defaultOption = INVENTORY_ARCADE_SORT_OPTIONS[8]
  } else if (query.show_only_listings) {
    result.options = LISTING_SORT_OPTIONS
    result.defaultOption = LISTING_SORT_OPTIONS[0]
  } else {
    result.options = INVENTORY_SORT_OPTIONS
    result.defaultOption = INVENTORY_SORT_OPTIONS[6]
  }

  result.options = options ?? result.options
  result.defaultOption = defaultOption ?? result.defaultOption

  return result
}
